export const pdfcss = (function () {
  return `
    html, body.kt-subheader--transparent {font-size:16px !important;}
    .row {max-width:100% !important}
    .row:after {content:"";display:table;clear:both;}
    #kt_subheader {display:none}
    .kt-subheader--transparent .kt-subheader {padding:0 0 20px 0 !important}
    .kt-content {padding: 0 !important}
    table, th, td {font-size:1rem !important;}
    .kt-portlet {font-size:1.1rem !important;font-weight:400 !important;box-shadow:none;border:1px #ebedf2 solid;border-radius:3px !important;page-break-inside: avoid;}
    .kt-portlet .kt-portlet__head {padding:15px 25px !important;background-color: #f2f6fb;}
    .kt-portlet .kt-portlet__body {padding:25px !important}
    .kt-badge--bbw-color {display:inline-block}
    .no-pagebreack {page-break-inside: avoid;}
    .product-approve-buttons-block {display:none}
    .form-control { border: 0 !important;padding: 0 !important;height: auto !important;}
    .bbw-daterangepicker { display:block;border: 0 !important;padding: 0 !important;height: auto !important;line-height: 1.5rem !important;}
    .bbw-daterangepicker i { display:none;}
    .bbw-daterangepicker span.ml-2.mr-4 { margin:1 !important;}
    .btn.btn-brand {display:none}
    .js-product-save {display:none}
  `;
})();
